import React from 'react';
import { useDroppable } from '@dnd-kit/core';
import { Box, Typography } from '@mui/material';

export const DiaCalendario = ({
    id,
    dia,
    nombreDia,
    children,
    isExpanded = false,
    isToday,
    isCurrentMonth,
    onSelectDay,
}) => {
    const { setNodeRef, isOver } = useDroppable({ id });
    const tieneContenido = React.Children.count(children) > 0;
    const alturaContenido = isExpanded ? 470 : 186;
    const colorPastel = 'rgba(229, 57, 53, 0.16)';
    const colorPastelHoy = 'rgba(229, 57, 53, 0.28)';

    return (
        <Box
            ref={setNodeRef}
            onClick={(event) => {
                if (!event.currentTarget.contains(event.target)) return;
                if (event.defaultPrevented) return;
                if (event.target.closest('[data-calendario-evento="true"]')) return;
                onSelectDay(id);
            }}
            sx={{
                minHeight: alturaContenido + 38,
                borderRadius: '10px',
                border: isToday ? '2px solid var(--principal)' : '1px solid rgba(229, 57, 53, 0.16)',
                backgroundColor: isOver
                    ? 'rgba(229, 57, 53, 0.12)'
                    : isCurrentMonth
                        ? '#ffffff'
                        : 'rgba(255, 248, 248, 0.72)',
                boxShadow: isToday ? '0 12px 24px rgba(229, 57, 53, 0.12)' : 'none',
                overflow: 'hidden',
                cursor: 'pointer',
                transition: 'box-shadow 0.18s ease, transform 0.18s ease',
                '&:hover': {
                    transform: 'translateY(-2px)',
                    boxShadow: '0 12px 22px rgba(229, 57, 53, 0.1)',
                },
            }}
        >
            <Box
                sx={{
                    minHeight: 38,
                    px: 1,
                    py: 0.75,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    gap: 1,
                    backgroundColor: isToday
                        ? colorPastelHoy
                        : isCurrentMonth
                            ? colorPastel
                            : 'rgba(229, 57, 53, 0.1)',
                    color: '#111111',
                    borderBottom: '1px solid rgba(229, 57, 53, 0.14)',
                }}
            >
                <Typography sx={{ fontSize: 12, fontWeight: 700, opacity: isCurrentMonth ? 1 : 0.75 }} noWrap>
                    {nombreDia}
                </Typography>

                <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.7, flexShrink: 0 }}>
                    {isToday && (
                        <Box
                            sx={{
                                px: 0.75,
                                py: 0.15,
                                borderRadius: 999,
                                backgroundColor: '#fff',
                                border: '1px solid rgba(229, 57, 53, 0.16)',
                                color: 'var(--principal)',
                                fontSize: 10,
                                fontWeight: 700,
                                lineHeight: 1.5,
                            }}
                        >
                            Hoy
                        </Box>
                    )}
                    <Typography sx={{ fontSize: 15, fontWeight: 800, lineHeight: 1 }}>
                        {dia}
                    </Typography>
                </Box>
            </Box>

            <Box
                sx={{
                    display: 'grid',
                    gap: 0.75,
                    alignContent: 'start',
                    minHeight: alturaContenido,
                    px: tieneContenido ? 0.6 : 0.8,
                    pt: 0.8,
                    pb: 0.9,
                }}
            >
                {children}
            </Box>
        </Box>
    );
};
